import { SHOP_STRIPE_ROOT_PATH } from './constants';

// import { SHOP_PRODUCT_ROUTER_ROOT, SHOP_STRIPE_ROOT_PATH } from './constants';

// import { SHOP_PROMOTE_ROUTER_CREATE } from './ProductPromoteForm/constants';
// import ProductList from './ProductList';
// import ProductPromoteForm from './ProductPromoteForm';
import StripePage from './StripePage';

const router = {
  path: SHOP_STRIPE_ROOT_PATH,
  component: StripePage
  // path: SHOP_PRODUCT_ROUTER_ROOT,
  // component: ProductList,
  // childRoutes: [
  //   // add promote
  //   {
  //     path: SHOP_PROMOTE_ROUTER_CREATE,
  //     component: ProductPromoteForm
  //   },
  //   {
  //     path: SHOP_STRIPE_ROOT_PATH,
  //     component: StripePage
  //   }
  // ]
};


export default {
  router
}



// WEBPACK FOOTER //
// ./src/components/Shop/index.js